module.exports = __webpack_public_path__ + "img/017.23c98935.png";